<template>
   <router-view />
</template>

<script>
export default {
   name: 'BasePage.vue',
};
</script>
